import { Fragment } from "react";
import { useState } from "react";
import "./SoftwareDevelopment.css";
import { softwaredevService } from "../../staticdata";
import webapplication from "../../assets/images/services/software/webapplication.png";
import mobileapplication from "../../assets/images/services/software/mobileapplication.png";
import artificialintelligence from "../../assets/images/services/software/artificialintelligence.png";
import blockchaintech from "../../assets/images/services/software/blockchaintech.png";
import virtualreality from "../../assets/images/services/software/virtualreality.png";

const SoftwareDevelopment = () => {
  const [active, setActive] = useState(softwaredevService[0]);

  return (
    <Fragment>
      <section className="softwaredev-style">
        <div className="app-banner">
          <div className="banner-overlay"></div>
          <div
            className="banner-content"
            data-aos="fade-down"
            data-aos-offset="300"
          >
            <h1 className="fw-bold">Software Development Company</h1>
            <p>
              Transverse business across the world by outsourcing your
              requirements to a leading software development company in india.
              Kairaa offers top-notch qualitative services to businesses by
              developing robust, secure and high-performing software solutions
              with exemplary user experience.
            </p>
          </div>
        </div>
        <div className="software-experience-container">
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <div className="experience-data">
                  <h1 className="fade-item delay-1">10+</h1>
                  <p>Year of experience</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="experience-data">
                  <h1 className="fade-item delay-2">300+</h1>
                  <p>IT Professionals</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="experience-data">
                  <h1 className="fade-item delay-3">1000+</h1>
                  <p>Success Stories</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="experience-data">
                  <h1 className="fade-item delay-3">10+</h1>
                  <p>Industries Covered</p>
                </div>
              </div>
            </div>
            <p className="text-start mt-4">
              Our unwavering commitment to excellence, deep technical expertise,
              and a strong focus on client satisfaction have made us the
              preferred choice for businesses worldwide seeking cutting-edge
              software solutions.
            </p>
          </div>
        </div>
        <div className="software-service">
          <h1 data-aos="fade-down" data-aos-offset="200">
            Our All-inclusive software development services
          </h1>
          <div className="service-content-container">
            <div className="row mt-2">
              {/* LEFT SIDE */}
              <div className="col-md-5">
                <div className="left-side">
                  {softwaredevService.map((item, index) => (
                    <div
                      key={item.id}
                      className={`service-item ${
                        active.id === item.id ? "active" : ""
                      }`}
                      onMouseEnter={() => setActive(item)}
                      data-aos="fade-down"
                      data-aos-delay={index * 200}
                      data-aos-duration="1200"
                    >
                      <h6>{item.title}</h6>
                    </div>
                  ))}
                </div>
              </div>

              {/* RIGHT SIDE */}
              <div className="col-md-7 d-flex align-items-center justify-content-center">
                <div
                  className="right-side"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                  data-aos-duration="1200"
                >
                  <div className="img-container">
                    <img
                      src={active.image}
                      alt="img-not-found"
                      loading="lazy"
                    />
                  </div>
                  <h5>{active.title}</h5>
                  <p>{active.description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="softwaretech-container">
          <div className="container">
            <div className="row">
              <div
                className="col-md-4"
                data-aos="fade-left"
                data-aos-delay="200"
                data-aos-duration="1200"
              >
                <h3>Driven by Modern Tech </h3>
                <p>
                  Our team can assist you in transforming your business with the
                  latest tech capabilities to stay ahead of the curve.
                </p>
              </div>
              <div className="col-md-8">
                <div className="row">
                  <div
                    className="col-md-2"
                    data-aos="fade-right"
                    data-aos-delay="200"
                    data-aos-duration="1200"
                  >
                    <h6>Web Application</h6>
                    <div className="software-tech-image">
                      <img src={webapplication} alt="img-not-found" />
                    </div>
                  </div>
                  <div
                    className="col-md-2"
                    data-aos="fade-right"
                    data-aos-delay="400"
                    data-aos-duration="1200"
                  >
                    <h6>Mobile Application</h6>
                    <div className="software-tech-image">
                      <img src={mobileapplication} alt="img-not-found" />
                    </div>
                  </div>
                  <div
                    className="col-md-3"
                    data-aos="fade-right"
                    data-aos-delay="600"
                    data-aos-duration="1200"
                  >
                    <h6>Artificial Intelligence & Machine Learning</h6>
                    <div className="software-tech-image">
                      <img src={artificialintelligence} alt="img-not-found" />
                    </div>
                  </div>
                  <div
                    className="col-md-2"
                    data-aos="fade-right"
                    data-aos-delay="800"
                    data-aos-duration="1200"
                  >
                    <h6>Blockchain & Web3 Technologies</h6>
                    <div className="software-tech-image">
                      <img src={blockchaintech} alt="img-not-found" />
                    </div>
                  </div>
                  <div
                    className="col-md-3"
                    data-aos="fade-right"
                    data-aos-delay="1000"
                    data-aos-duration="1200"
                  >
                    <h6>Augmented Reality (AR) & Virtual Reality (VR)</h6>
                    <div className="software-tech-image">
                      <img src={virtualreality} alt="img-not-found" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default SoftwareDevelopment;
